import React from "react";
import { AlertTriangle, Layers3 } from "lucide-react";

export default function LmsContentDetailPanel({ sections, blockingContents }) {
  return (
    <aside className="lms-content-panel">
      <div className="lms-panel-title">
        <Layers3 size={17} />
        <span>Progression par section</span>
      </div>
      <div className="lms-section-list">
        {(sections || []).map((section) => (
          <article className="lms-section-card" key={section.sectionId}>
            <div>
              <strong>{section.title}</strong>
              <span>{section.completedContentsCount || 0} / {section.totalContentsCount || 0} contenus</span>
            </div>
            <div className="lms-progress-cell">
              <div style={{ width: `${Math.max(0, Math.min(section.progressPercent || 0, 100))}%` }} />
            </div>
            <span>{section.progressPercent || 0}%</span>
          </article>
        ))}
      </div>

      <div className="lms-panel-title lms-panel-title--spaced">
        <AlertTriangle size={17} />
        <span>Contenus bloquants</span>
      </div>
      {(blockingContents || []).length ? (
        <div className="lms-blocking-list">
          {blockingContents.slice(0, 8).map((content) => (
            <article className="lms-blocking-card" key={`${content.userId}-${content.contentId}`}>
              <strong>{content.title}</strong>
              <span>{content.userFullName}</span>
              <em>{content.blockingReason || content.status}</em>
            </article>
          ))}
        </div>
      ) : (
        <div className="lms-report-empty compact">Aucun contenu bloquant détecté.</div>
      )}
    </aside>
  );
}
